module.exports = __webpack_public_path__ + "assets/fonts/iconfont.c891009f.woff";